import React from 'react'
import { Link } from 'react-router-dom'

function SignMail() {
  return (
    <div className='h-screen background'>
        <div className='absolute bottom-72 flex flex-col items-center'>
            <h3 className='text-2xl font-bold'>Ahoy!</h3>
            <p className='px-10 text-center text-xs mt-8'>Lorem ipsum dolor sit amet consectetur. Ut cursus adipiscing dolor velit. Viverra tristique et et nunc nulla pharetra vel arcu ut.</p>
        
        </div>
        <div className='absolute bottom-16 flex flex-col items-center w-full'>
            <input className='px-4 py-2 rounded-xl mb-6 ' type="text" placeholder='Enter Username' />
            <input className='px-4 py-2 rounded-xl mb-12' type="text" name="" id="" placeholder='Enter email address' />
            <Link to='/profilecreate' className='px-7 py-3 bg-black font-semibold text-white rounded-3xl'>Submit Recover Email</Link>
        </div>
    </div>
  )
}

export default SignMail